import { GET_USERS_BY_QUERY, setUsersByQuery, setUsersByQueryError } from './actions'
import { searchUsersByQuery } from '../../index'

const log = console
const storeKey = 'userSearch'

async function getUsersByQueryHandler ({ store, action }) {
  const { config, auth } = store.getState()
  const {
    uid,
    uuid,
    billingAccountId,
    billingAccountNumber,
    username,
    usernameLike,
    email,
    emailLike,
    firstName,
    firstNameLike,
    lastName,
    lastNameLike,
    name,
    invoiceNumber,
    paymentNumber,
    ccLast4,
    recurringPaymentId,
    yogaInternationalUserId,
    page,
    perPage,
  } = action.payload
  try {
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'auth']),
      uid,
      uuid,
      billingAccountId,
      billingAccountNumber,
      username,
      usernameLike,
      email,
      emailLike,
      firstName,
      firstNameLike,
      lastName,
      lastNameLike,
      name,
      invoiceNumber,
      paymentNumber,
      ccLast4,
      recurringPaymentId,
      yogaInternationalUserId,
      page,
      perPage,
    }

    const data = await searchUsersByQuery(options)
    store.dispatch(
      setUsersByQuery({
        storeKey,
        data,
      }),
    )
  } catch (error) {
    log.error(error, 'Error searching for user.')
    store.dispatch(
      setUsersByQueryError({
        storeKey,
        error,
      }),
    )
  }
}

export default (store) => (next) => (action) => {
  const { type } = action
  switch (type) {
    case GET_USERS_BY_QUERY:
      getUsersByQueryHandler({ store, action })
      break
    default:
      break
  }
  next(action)
}
